import { client } from 'app/http';

export const upsertRepository = async (createRepositoryDto: any) => {
  const { data } = await client.post('/repositories', createRepositoryDto);
  return data;
};
